// extracted by mini-css-extract-plugin
export var container = "_fn-0";
export var icon = "_fn-1";
export var text = "_fn-2";